const SHARED_SETTINGS = {
  schoolName: 'The STEM Lab',
  abDayRule: 'even=A, odd=B',
  schedule: {
    activeGrades: ['6', '7', '8'],
    classSchedule: {
      //Regular Schedule
      '6': [10, 24, 11, 27],
      '7': [13, 31, 14, 34],
      '8': [14, 37, 15, 40]
      //Early Realease
      // '6': [9, 28, 10, 03],
      // '7': [10, 42, 11, 17],
      // '8': [11, 19, 11, 54]
    },
    schoolCalendar: {
      academicYear: '2026-2027',
      firstStudentDay: '2026-08-24',
      secondSemesterStart: '2027-01-06',
      lastStudentDay: '2027-06-02',
      noSchoolDates: [
        '2026-09-07',
        '2026-11-03',
        '2026-11-11',
        '2026-11-25', '2026-11-26', '2026-11-27',
        '2026-12-21', '2026-12-22', '2026-12-23', '2026-12-24', '2026-12-25',
        '2026-12-28', '2026-12-29', '2026-12-30', '2026-12-31',
        '2027-01-01', '2027-01-04', '2027-01-05', '2027-01-18',
        '2027-02-10',
        '2027-03-01', '2027-03-02', '2027-03-03', '2027-03-04', '2027-03-05',
        '2027-03-26', '2027-03-29',
        '2027-04-21',
        '2027-05-31'
      ]
    }
  },
  weather: {
    enabled: true,
    latitude: 34.37,
    longitude: -77.71
  }
};

const DAILY_QUOTES = {
  "A": [
    "Curiosity turns an ordinary question into a doorway.",
    "Good designs begin as rough ideas brave enough to be tested.",
    "A careful observation can be the first tool of discovery.",
    "Progress is built from tiny improvements noticed on purpose.",
    "When evidence changes, strong thinkers change with it.",
    "Creativity is engineering with room to explore.",
    "A mistake becomes useful the moment you learn from it.",
    "The best question is often the one nobody asked yet.",
    "Every prototype teaches something the sketch could not.",
    "Skill grows when practice has a purpose.",
    "A problem is an invitation to make something better.",
    "Engineers listen to failures because failures have data.",
    "Your next idea does not need permission to be interesting.",
    "Precision is kindness to the people who use your work.",
    "A team becomes stronger when every voice improves the plan.",
    "Make your first version clear enough to test, not perfect enough to hide.",
    "Real confidence comes from trying again with better information.",
    "A small measurement can settle a large argument.",
    "Imagination gives science new places to look.",
    "A useful question can be more powerful than a quick answer.",
    "Build with patience; strong results take more than one attempt.",
    "Good collaborators share credit and share the messy work.",
    "A design earns trust when it works for more than its creator.",
    "Notice patterns; they are clues wearing everyday clothes.",
    "The goal of a test is learning, not proving yourself right.",
    "A chart is a story data tells when it is organized.",
    "New solutions begin when you refuse to stop at almost.",
    "Every expert once needed someone to explain the first step.",
    "Persistence is curiosity that stayed after the easy part.",
    "The right tool is the one that helps you understand more.",
    "Great ideas are often ordinary observations seen differently.",
    "Take notes like your future self will need a map.",
    "Questions make room for discoveries facts alone cannot make.",
    "A thoughtful pause can save an hour of rebuilding.",
    "Models are small worlds where big ideas can be tested.",
    "Improvement starts by naming what happened honestly.",
    "A strong plan leaves space for surprises.",
    "Technology matters most when it helps people do something better.",
    "Compare results before deciding what they mean.",
    "Learning is not a race; it is a collection of useful tries.",
    "A careful diagram can prevent a careless mistake.",
    "Inventors keep looking after the first answer appears.",
    "The clearest explanation is a gift to your audience.",
    "Data becomes powerful when you ask it a fair question.",
    "Good design balances what is possible with what is helpful.",
    "Be brave enough to revise a favorite idea.",
    "Research begins with admitting there is more to know.",
    "The most interesting problems rarely arrive with directions.",
    "A reliable result is worth more than a lucky guess.",
    "Your notebook can hold ideas that change after you leave the room.",
    "Test one variable at a time when you want the answer to speak clearly.",
    "A measurement is a promise to be specific.",
    "Build for the person who will use it, not just the person who imagined it.",
    "Curiosity makes ordinary materials feel full of possibilities.",
    "A surprising result is not bad news; it is a new clue.",
    "Every solution has a tradeoff worth noticing.",
    "Thoughtful questions make teams move faster together.",
    "Revisions are proof that your ideas are still alive.",
    "A map, model, or table can turn confusion into a next step.",
    "Challenge assumptions gently, then test them carefully.",
    "Learning becomes durable when you explain it in your own words.",
    "Choose evidence over guesses when the two disagree.",
    "The best builders know when to measure before cutting.",
    "An unfinished idea can still be a valuable beginning.",
    "Science rewards people who look closely more than once.",
    "A simple solution is powerful when it solves the real problem.",
    "Every experiment is a conversation with the world.",
    "Use constraints to focus your creativity.",
    "A good teammate makes the whole project easier to understand.",
    "Observe first; improve second.",
    "A useful invention starts with someone noticing a need.",
    "Keep the part that works and rethink the part that does not.",
    "Big discoveries can start with a very small difference.",
    "Reasoning is the bridge between data and decisions.",
    "Do not fear complicated questions; break them into smaller ones.",
    "Practice turns unfamiliar tools into familiar possibilities.",
    "A claim becomes stronger when it can survive a fair test.",
    "Good questions travel farther than quick opinions.",
    "Innovation is what happens when effort meets attention.",
    "Create something today that your tomorrow self can improve.",
    "Details are where a design proves it cares.",
    "A hypothesis is a prediction waiting to meet evidence.",
    "Collaborate with people who notice what you missed.",
    "The first draft is not the final verdict.",
    "Measurement helps imagination become buildable.",
    "A setback can point directly toward the next experiment.",
    "Learn the rule, then ask what it helps you predict.",
    "Smart risks are planned, observed, and adjusted.",
    "Your ideas deserve the chance to become evidence."
  ],
  "B": [
    "A fresh perspective can turn a familiar problem into a new challenge.",
    "Work carefully enough that someone else can repeat what you did.",
    "The strongest ideas can handle questions.",
    "Learning to notice is the beginning of learning to design.",
    "Every material has a story about what it can and cannot do.",
    "An answer becomes useful when you understand why it works.",
    "Start where you are, then improve what you can measure.",
    "Good experiments make room for surprises.",
    "The most valuable tool in the room may be a well-kept notebook.",
    "Share incomplete ideas; collaboration can make them stronger.",
    "A sketch is a conversation between your brain and your hands.",
    "Solve the problem in front of you before chasing a fancier one.",
    "A thoughtful test can save a whole project from guesswork.",
    "Curiosity is a habit you can practice.",
    "You can learn as much from the edge of a failure as from a success.",
    "Build with enough care that your result can teach someone else.",
    "A question with evidence behind it can change a plan.",
    "Keep your mind flexible; new information is part of the job.",
    "Good science is honest about what remains uncertain.",
    "A useful design begins by listening to people.",
    "The world is full of systems waiting to be understood.",
    "Test ideas in the smallest safe way first.",
    "Measurement gives your imagination a way to check itself.",
    "Clear labels make smart work easier to share.",
    "A strong solution usually has more than one good reason behind it.",
    "A prototype is permission to learn before you are finished.",
    "The next improvement is often hiding in the last observation.",
    "Be precise with facts and generous with teammates.",
    "One careful comparison can uncover a pattern.",
    "A problem gets smaller when you name its parts.",
    "Build knowledge the way you build a bridge: connection by connection.",
    "A result you can explain is more valuable than one you can only report.",
    "Your questions set the direction for your discoveries.",
    "Creativity grows when constraints give it a puzzle.",
    "A design is never just an object; it is an answer to a need.",
    "Look for evidence that challenges your favorite idea.",
    "A useful model makes invisible thinking easier to see.",
    "Slow down long enough to understand what the data is saying.",
    "Curiosity is the engine; effort is the steering wheel.",
    "Honest revision is a form of respect for the problem.",
    "Ideas get stronger when they travel through a team.",
    "Ask what changed before you ask what went wrong.",
    "A good plan includes a way to learn from the unexpected.",
    "Do not rush past the detail that seems out of place.",
    "Design choices are decisions with consequences.",
    "The best improvements often begin with a better question.",
    "Build your explanation so it works even when you are not there.",
    "When results disagree, investigate before choosing a favorite.",
    "A fair test treats every option with the same care.",
    "Your imagination is a tool; sharpen it with observations.",
    "Make the first move small enough that you can learn from it.",
    "Each revision is a new chance to solve the real problem.",
    "Find the pattern, then ask what might be causing it.",
    "A test is successful when it makes your next decision easier.",
    "Practice noticing the difference between a fact and an assumption.",
    "Useful feedback points toward a next step.",
    "Strong teams turn many small ideas into one clear direction.",
    "Explain the reason, not just the result.",
    "A good build is part planning, part testing, and part listening.",
    "Let evidence do some of the persuading.",
    "Small details can change a whole system.",
    "A wise inventor asks who benefits from the solution.",
    "Questions are tools; choose one that fits the problem.",
    "A measurement is more helpful when you record its units.",
    "Smart work includes checking whether the answer makes sense.",
    "Learn the limits of a material before asking it to do more.",
    "A new attempt is not starting over; it is starting wiser.",
    "Research gives your ideas neighbors to learn from.",
    "Clarity is a kind of craftsmanship.",
    "A surprising observation deserves a second look.",
    "Create a plan that can survive a changed mind.",
    "A strong claim invites others to test it.",
    "The goal is not to be right first; it is to understand deeply.",
    "Use your mistakes as directions, not labels.",
    "Better questions create better experiments.",
    "A shared goal can turn separate effort into a real team.",
    "Test the parts before trusting the whole.",
    "Give your ideas enough time to show you what they need.",
    "Keep asking how, then ask why.",
    "Constraints can reveal solutions that freedom hides.",
    "A careful thinker leaves a trail someone else can follow.",
    "Every project teaches both a subject and a way of thinking.",
    "Think beyond whether it works; ask whom it helps.",
    "A clear process makes complicated work feel possible.",
    "The next discovery may be waiting in the note you almost ignored."
  ]
};

function buildProjectRotation(launchEntry, topics, bellringerTemplates, objectiveTemplates) {
  return Array.from({ length: 89 }, (_, index) => {
    if (index === 0) {
      return launchEntry;
    }

    const projectIndex = index - 1;
    const topic = topics[projectIndex % topics.length];
    return {
      bellringer: bellringerTemplates[projectIndex % bellringerTemplates.length].replace('{topic}', topic),
      objective: objectiveTemplates[projectIndex % objectiveTemplates.length].replace('{topic}', topic)
    };
  });
}

const GRADE_BOARD_CONTENT = {
  '6': {
    essentialIdea: 'A useful product balances a clear user need, dependable dispensing, and the realities of manufacturing.',
    rotationStartDate: '2026-10-05',
    rotation: buildProjectRotation(
      {
        bellringer: 'A cereal dispenser should make breakfast easier. What must it do well for its user?',
        objective: 'Define the need for a cereal dispenser and identify measurable signs of success.'
      },
      ['a user need', 'cereal flow', 'the dispensing mechanism', 'portion control', 'stability', 'material choice', 'manufacturing', 'safety', 'reliability', 'spill prevention', 'prototype testing', 'clear instructions', 'design tradeoffs'],
      [
        'What question should your team answer first about {topic}?',
        'How could a sketch help you think more clearly about {topic}?',
        'What would a fair test reveal about {topic}?',
        'What could go wrong with {topic}, and how could you prevent it?',
        'What measurement would help you improve {topic}?',
        'Which decision about {topic} matters most to the user?',
        'What evidence would convince you that {topic} is working?'
      ],
      [
        'Investigate {topic} for the cereal dispenser and record one design choice.',
        'Use a sketch to communicate a cereal-dispenser idea about {topic}.',
        'Plan a fair test that produces evidence about {topic}.',
        'Identify a risk involving {topic} and propose a practical solution.',
        'Measure or compare {topic} to guide an improvement.',
        'Justify a cereal-dispenser decision about {topic} from the user perspective.',
        'Use test evidence to evaluate {topic} and choose a next step.'
      ]
    )
  },
  '7': {
    essentialIdea: 'A successful board game uses clear rules, balanced choices, and feedback from real players.',
    rotationStartDate: '2026-10-05',
    rotation: buildProjectRotation(
      {
        bellringer: 'Think of a board game you enjoy. What keeps players making choices instead of simply waiting for the game to end?',
        objective: 'Identify a game goal, player choices, and rules that create an engaging experience.'
      },
      ['the game goal', 'player choices', 'game mechanics', 'the rules', 'turn flow', 'game balance', 'chance', 'strategy', 'game pieces', 'board layout', 'playtesting feedback', 'accessibility', 'written directions'],
      [
        'What question should your team answer first about {topic}?',
        'How could a sketch or quick prototype help you think about {topic}?',
        'What could you observe during a playtest to learn about {topic}?',
        'What might make {topic} confusing or unfair for players?',
        'What evidence would show that {topic} is working as intended?',
        'How could a player’s experience change because of {topic}?',
        'What revision could make {topic} clearer, fairer, or more fun?'
      ],
      [
        'Define a board-game choice about {topic} and explain why it supports the player experience.',
        'Use a sketch or prototype to communicate a game-design idea about {topic}.',
        'Plan a playtest that collects useful feedback about {topic}.',
        'Identify a problem with {topic} and propose a rule or design revision.',
        'Use player evidence to evaluate {topic} and support a decision.',
        'Analyze how {topic} affects fairness, challenge, and player choices.',
        'Revise {topic} using specific feedback from a playtest.'
      ]
    )
  },
  '8': {
    essentialIdea: 'A reliable robot combines a sturdy build, carefully connected systems, and repeated testing to complete its mission.',
    rotationStartDate: '2026-10-05',
    rotation: buildProjectRotation(
      {
        bellringer: 'A robot is built to complete a task. What are three things it must do reliably before you would trust it?',
        objective: 'Define the robot’s mission and identify measurable signs of a reliable build.'
      },
      ['the robot mission', 'the chassis', 'movement', 'motor connections', 'power', 'sensors', 'control code', 'turning', 'stability', 'an attachment', 'wiring', 'test data', 'design tradeoffs'],
      [
        'What question should your team answer first about {topic}?',
        'What could fail with {topic}, and how could you prevent it?',
        'What data would make a claim about {topic} more trustworthy?',
        'How could you test whether {topic} helps the robot complete its mission?',
        'What limitation of {topic} would you investigate before building further?',
        'What change to {topic} might improve performance but create a new problem?',
        'How would you defend a design decision about {topic} with evidence?'
      ],
      [
        'Define a measurable goal for {topic} and explain how it supports the robot mission.',
        'Identify a constraint involving {topic} and justify a design decision.',
        'Build or refine {topic}, then document evidence from a test.',
        'Compare alternatives for {topic} and explain the tradeoffs of your recommendation.',
        'Use data to diagnose a problem with {topic} and propose a targeted revision.',
        'Design a repeatable test for {topic} that another team could verify.',
        'Defend a robot-design decision about {topic} using evidence.'
      ]
    )
  }
};

const CLASS_RIDDLE_BANKS = {
  '6A': [
    'I am a wheel with teeth. When I turn, I can make another part turn too. What am I?',
    'Cereal waits inside me before it takes a trip down. What am I?',
    'I am a spinning screw that can move cereal forward. What am I?',
    'I slow moving parts when their surfaces rub. What am I?',
    'I help every bowl receive the same amount. What am I?',
    'I spread out under a tall invention so it will not topple. What am I?',
    'I am a first version built to learn from mistakes. What am I?',
    'I can block cereal or let it pass. What am I?',
    'I hold two parts together with a head and a threaded body. What am I?',
    'I am a labeled drawing that shows how something should be built. What am I?'
  ],
  '6B': [
    'I am a moving loop that carries items from one place to another. What am I?',
    'Push me down on one end and something lifts on the other. What am I?',
    'I am a slanted path that cereal can slide down. What am I?',
    'I run through the middle of a turning wheel. What am I?',
    'I pull cereal downward without touching it. What am I?',
    'I compare an object’s weight against a standard. What am I?',
    'I click shut to keep a door closed. What am I?',
    'I am wide at the top and narrow at the bottom, guiding cereal neatly. What am I?',
    'I reveal whether a dispenser truly works or needs a change. What am I?',
    'I am a planned series of steps used to make many matching products. What am I?'
  ],
  '7A': [
    'I tumble, land, and use dots to add surprise to a game. What am I?',
    'I explain how to play but never take a turn. What am I?',
    'I show who is ahead without choosing the winner. What am I?',
    'I am a careful plan for winning before the game is over. What am I?',
    'I tell players when it is their time to act. What am I?',
    'I hold spaces, paths, and places for game pieces. What am I?',
    'I can give you a challenge, a reward, or a surprise. What am I?',
    'I move around the board but cannot move by myself. What am I?',
    'I keep one player from having an unfair advantage. What am I?',
    'I am a trial run with real players that helps a game improve. What am I?'
  ],
  '7B': [
    'I spin around a center point and point to a random result. What am I?',
    'I am the thing every player is trying to achieve. What am I?',
    'I compete against you, but I also make the game more interesting. What am I?',
    'I am a stack of cards waiting to be drawn. What am I?',
    'I offer a faster path, but players may have to earn the right to use me. What am I?',
    'I add uncertainty, so the same game can play differently each time. What am I?',
    'I limit how long a player can think or act. What am I?',
    'I tell players what they may and may not do. What am I?',
    'I am information from players that helps designers improve a game. What am I?',
    'I reach the game’s goal first. What am I?'
  ],
  '8A': [
    'I turn electrical energy into motion. What am I?',
    'I notice something in the robot’s surroundings and send information back. What am I?',
    'I store energy so a robot can work without being plugged in. What am I?',
    'I am the robot’s main frame, holding important parts in place. What am I?',
    'I roll along the ground and help a robot travel. What am I?',
    'I am a set of instructions that tells a robot what to do. What am I?',
    'I have teeth that change speed or turning force when I work with another gear. What am I?',
    'I carry electricity from one robot part to another. What am I?',
    'I reveal whether a robot performs its task reliably. What am I?',
    'I am a step-by-step plan a robot can follow to solve a problem. What am I?'
  ],
  '8B': [
    'I am a motor that can move to a specific position and hold it. What am I?',
    'I am the small computer that receives code and controls a robot. What am I?',
    'I run through the center of a wheel and help it turn. What am I?',
    'I open or close an electrical path. What am I?',
    'I repeat the same instructions until a condition changes. What am I?',
    'I support a robot’s parts and give its structure shape. What am I?',
    'I join two parts so power or information can travel between them. What am I?',
    'I make a sensor or motor more accurate by comparing it with a known value. What am I?',
    'I am the process of finding and fixing mistakes in code or a build. What am I?',
    'I include the motors, wheels, and parts that make a robot move. What am I?'
  ]
};

const CLASS_CONTENT_OVERRIDES = {
  '6A': { rotationOffset: 0, riddleIndex: 0 },
  '6B': { rotationOffset: 0, riddleIndex: 0 },
  '7A': { rotationOffset: 0, riddleIndex: 0 },
  '7B': { rotationOffset: 0, riddleIndex: 0 },
  '8A': { rotationOffset: 0, riddleIndex: 0 },
  '8B': { rotationOffset: 0, riddleIndex: 0 }
};

const AGENDA_BOARD = {
  bellringerTimerSeconds: 180,
  classes: {
    '6A': { code: 'mew7x6cz' },
    '6B': { code: '2ndkpixu' },
    '7A': { code: 'rwrcdgec' },
    '7B': { code: 'c7dsx4wl' },
    '8A': { code: 'ji6kmmoh' },
    '8B': { code: 'xdcwwnkl' }
  }
};

const TIMER_BOARD = {
  timer: {
    defaultMinutes: 63,
    warningMinutes: 10,
    endingMinutes: 3
  },
  reminders: {
    title: 'Today’s Project Focus',
    grades: {
      '6': 'Cereal Dispenser: Start with the user need. Sketch how cereal will enter, move through, and exit your invention.',
      '7': 'Board Game Design: Choose a clear goal, player choices, and rules that make the game fun and fair.',
      '8': 'First Robot Build: Build carefully, connect each part securely, and test every movement one step at a time.'
    }
  },
  projects: {
    '6': {
      icon: '🥣',
      title: 'Cereal Dispenser Design',
      current: 'Design a reliable cereal dispenser that solves a real user need.',
      next: 'Next step: create a labeled sketch of the hopper, dispenser mechanism, and base.'
    },
    '7': {
      icon: '🎲',
      title: 'Board Game Design',
      current: 'Create a board game with a clear goal, meaningful player choices, and fair rules.',
      next: 'Next step: decide what players do on a turn and how someone wins.'
    },
    '8': {
      icon: '🤖',
      title: 'First Robot Build',
      current: 'Build a dependable robot that can complete its assigned task.',
      next: 'Next step: define the mission, build the chassis, and test the first movement.'
    }
  }
};

const RESEARCH_BOARD = {
  focus: 'Research ideas that can strengthen your student-choice STEM project.',
  question: 'What have other people already designed, discovered, or built that can inspire your project?',
  sourceRules: [
    'Use at least 2 trustworthy sources.',
    'Take notes in your own words.',
    'Look for facts, examples, and useful design ideas.',
    'Avoid random sites with no author or evidence.'
  ],
  whatToFind: [
    '1 helpful fact connected to your idea',
    '1 example or design you can learn from',
    '1 source with evidence you can cite',
    '1 new idea you could test in your own project'
  ],
  helpfulStems: [
    'I learned that...',
    'This matters because...',
    'A design idea this gives me is...',
    'One source I trust is...'
  ],
  checkpoint: 'Before you leave: 2 sources, 3 notes, and 1 clear next step for your project.'
};
